import React from 'react'
import { connect } from 'react-redux'
import { SvgIcon, withStyles } from '@material-ui/core'
import classNames from 'classnames'
import styles from './styles'

export default connect(
  (state, { errorLocation }) => ({
    error:
      errorLocation && state[errorLocation].validationError
        ? state[errorLocation].validationError
        : false,
  }),
  null
)(
  withStyles(styles)(({ classes, active, completed, error, textContent }) => (
    <SvgIcon
      className={classNames(classes.stepIconRoot, {
        [classes.active]: active,
        [classes.completed]: completed,
        [classes.error]: error,
      })}
    >
      <circle cx="12" cy="12" r="12" />
      <text className={classes.stepIconText} x="12" y="16" textAnchor="middle">
        {textContent}
      </text>
    </SvgIcon>
  ))
)
